export default [
  {
    path: '/segmentbase',
    name: 'segmentbase',
    component: () => import('@/views/menu/notification/segmentBase.vue'),
    meta: {
      pageTitle: 'سگمنت پایه',
      action: 'show',
      resource: 'SegmentManager',
    },
  },
  {
    path: '/notificationList',
    name: 'notificationList',
    component: () => import('@/views/menu/notification/notificationList.vue'),
    meta: {
      pageTitle: 'لیست پیام',
      action: 'show',
      resource: 'NotificationManager',
    },
  },
  {
    path: '/listSegment',
    name: 'listSegment',
    component: () => import('@/views/menu/notification/listSegment.vue'),
    meta: {
      pageTitle: ' لیست سگمنت',
      action: 'show',
      resource: 'SegmentManager',
    },
  },
  {
    path: '/customSegment/:id?',
    name: 'customSegment',
    component: () => import('@/views/menu/notification/customSegment.vue'),
    meta: {
      pageTitle: 'سگمنت سفارشی',
      action: 'show',
      resource: 'SegmentManager',
    },
  },
  {
    path: '/reportSegment',
    name: 'reportSegment',
    component: () => import('@/views/menu/notification/reportSegment.vue'),
    meta: {
      pageTitle: 'گزارش پیام',
      action: 'show',
      resource: 'NotificationManager',
    },
  },
  {
    path: '/messageInbox',
    name: 'messageInbox',
    component: () => import('@/views/menu/notification/reportSegment.vue'),
    meta: {
      pageTitle: 'صندوق پیام',
      action: 'show',
      resource: 'NotificationManager',
    },
  },
  {
    path: '/sendNotification/:messageId?/:customSegmentId?',
    name: 'sendNotification',
    component: () => import('@/views/menu/notification/sendNotification.vue'),
    meta: {
      pageTitle: 'ارسال پیام',
      action: 'show',
      resource: 'NotificationManager',
    },
  },
  {
    path: '/segment-reports',
    name: 'segmentReports',
    component: () => import('@/views/menu/notification/segmentReportList.vue'),
    meta: {
      pageTitle: 'گزارش سگمنت ها',
      action: 'show',
      resource: 'SegmentManager',
    },
  },
]
